import { all } from 'redux-saga/effects';

import companies from './companies';
import branches from './branches';
import personnels from './personnels';
import users from './users';
import settings from './settings';
import accidents from './accidents';
import events from './events';
import hazards from './hazards';
import courses from './courses';

export default function* rootSaga() {
  yield all([
    ...companies(),
    ...branches(),
    ...users(),
    ...settings(),
    ...personnels(),
    ...accidents(),
    ...events(),
    ...hazards(),
    ...courses()
  ]);
}
